import Swiper from 'swiper';
import { Navigation, Pagination, Parallax } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/parallax';

export default el => {
    const swiper = new Swiper(el, {
    	modules: [Navigation, Pagination, Parallax],
    	parallax: true,
    	speed: 600,
    	spaceBetween: 20,
        grabCursor: true,
        loop: true,
    	pagination: {
    	  el: ".swiper-pagination",
    	  clickable: true,
    	},
    	navigation: {
    	  nextEl: el.querySelector(".next"),
    	  prevEl: el.querySelector(".prev"),
    	},
    });
};
